class IngredientsModal extends HTMLElement {
  constructor() {
    super();
    this.init();
  }
  init() {

    const ingredientsModal = document.getElementById('ingredients-modal');
    const ingredientsOpenModalBtn = document.getElementById('ingredients-open-modal');
    const ingredientsCloseModalBtn = document.getElementById('ingredients-close-modal');
    ingredientsOpenModalBtn?.addEventListener('click', () => {
      ingredientsModal.classList.add('open');
    });

    document.addEventListener('click', (event) => {
  
      if (!ingredientsModal?.contains(event.target) && event.target !== ingredientsOpenModalBtn) {
        ingredientsModal?.classList.remove('open');
        document.body.classList.remove('no-scroll');
      }
    
      
    });

    ingredientsCloseModalBtn?.addEventListener('click', () => {
      ingredientsModal?.classList.remove('open');
      document.body.classList.remove('no-scroll');
    });


  }
}
customElements.define("ingredients-modal", IngredientsModal);